import React, { useEffect, useRef, useState } from 'react';

import styled from '@emotion/styled';

import CustomSelectField from '../../../components/FormCom/CustomSelectField';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { GeneralFilterSchema } from '../../../models/dashboard/filter-forms/general-filter.model';

type RatingMetricsLineChartFilterFilter = {
  year: string;
  month: string;
};

const monthOptions = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const monthNameToNumber: Record<string, string> = {
  january: '01',
  february: '02',
  march: '03',
  april: '04',
  may: '05',
  june: '06',
  july: '07',
  august: '08',
  september: '09',
  october: '10',
  november: '11',
  december: '12',
};

const now = new Date();
const formInitialState: RatingMetricsLineChartFilterFilter = {
  year: now.getFullYear().toString(),
  month: monthOptions[now.getMonth()],
};

interface RatingMetricsLineChartFilterProps {
  setDataUrl: (url: string) => void;
  dataUrl: string;
}

const RatingMetricsLineChartFilter: React.FC<
  RatingMetricsLineChartFilterProps
> = ({ setDataUrl, dataUrl }) => {
  const baseDataUrlRef = useRef(dataUrl);
  const [filterObj, setFilterObj] =
    useState<Partial<RatingMetricsLineChartFilterFilter>>(formInitialState);

  useEffect(() => {
    const baseUrl = baseDataUrlRef.current;

    const selectedYear = String(filterObj.year ?? '').trim();
    const selectedMonthName = String(filterObj.month ?? '')
      .trim()
      .toLowerCase();
    const selectedMonthNumber = monthNameToNumber[selectedMonthName];

    const queryString =
      selectedYear && selectedMonthNumber
        ? `month=${encodeURIComponent(`${selectedYear}-${selectedMonthNumber}`)}`
        : '';

    if (!queryString) {
      setDataUrl(baseUrl);
      return;
    }

    if (baseUrl.includes('?')) {
      const separator =
        baseUrl.endsWith('?') || baseUrl.endsWith('&') ? '' : '&';
      setDataUrl(`${baseUrl}${separator}${queryString}`);
      return;
    }

    setDataUrl(`${baseUrl}?${queryString}`);
  }, [filterObj, setDataUrl]);

  const handleOnSubmit = () => {};

  const handleFieldChange = (
    fieldName: keyof RatingMetricsLineChartFilterFilter,
  ) => {
    return (value: string) => {
      setFilterObj((prevFilter) => ({
        ...prevFilter,
        [fieldName]: value,
      }));
    };
  };

  return (
    <Container>
      <WrapFormComponent
        initialValues={formInitialState}
        schema={GeneralFilterSchema}
        onSubmit={handleOnSubmit}
      >
        <CustomSelectField
          name='year'
          id='year'
          placeholder='Year'
          onChange={handleFieldChange('year')}
          optionData={Array.from({ length: 77 }, (_, i) =>
            (2026 + i).toString(),
          )}
        />
        <CustomSelectField
          name='month'
          id='month'
          placeholder='Month'
          onChange={handleFieldChange('month')}
          optionData={monthOptions}
        />
      </WrapFormComponent>
    </Container>
  );
};

export default RatingMetricsLineChartFilter;

const Container = styled.div`
  @media (max-width: 884px) {
    width: 100%;
  }
`;

const WrapFormComponent = styled(FormComponent)`
  display: grid;
  grid-template-columns: 109px 133px;
  gap: 8px;
`;
